import React from 'react';
import { useTranslation } from 'react-i18next';
import DownloadButton from './DownloadButton';

type Props = {
  titleKey?: string;
  descriptionKey?: string;
  downloadKey?: string;
  imageSrc?: string;
  imageAlt?: string;
  maxWidthClass?: string;
};

export default function UnavailableFeature({
  titleKey = 'page.chats.unavailable',
  descriptionKey = 'page.chats.unavailableDescription',
  downloadKey = 'page.chats.downloadApp',
  imageSrc = '/images/figures/mess.svg',
  imageAlt = 'Vera Messy',
  maxWidthClass = 'max-w-md',
}: Props) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center gap-6 p-8">
      <div className={`text-center ${maxWidthClass}`}>
        <div className="mb-6 flex justify-center">
          <img src={imageSrc} alt={imageAlt} className="h-96 w-96 object-contain" />
        </div>

        <h2 className="mb-4 text-2xl font-semibold text-primary">{t(titleKey)}</h2>
        <p className="mb-6 text-details/70">{t(descriptionKey)}</p>

        <div className="mb-4">
          <p className="mb-4 text-sm text-details/70">{t(downloadKey)}</p>
          <div className="flex justify-center">
            <DownloadButton />
          </div>
        </div>
      </div>
    </div>
  );
}
